{
  "action": "Azione:",
  "actionName": "Azione",
  "activeDatesLabel": "Date attive",
  "activeDatesValueWithStartAndEnd": "{{start, datetime}} - {{end, datetime}}",
  "activeDatesWithStart": "{{start, datetime}}",
  "cancel": "Cancellare",
  "datetimeWithVal": "{{val, datetime}}",
  "delete": "Eliminare",
  "deleteThisSchedule": "Eliminare questa pianificazione?",
  "endTimeLabel": "FINE",
  "executeAt": "Eseguire a",
  "executeAtWithTimestamp": "{{timestamp, datetime}}",
  "executeOnceOn": "Esegui una volta su:",
  "executeOnceOnWithDate": "Esegui una volta il {{val, datetime}}",
  "executionTime": "Tempo di esecuzione",
  "executionWithStartAndEnd": "{{start, datetime}} - {{end, datetime}}",
  "executionWithStartAndEndAndTimezone": "{{start, datetime}} - {{end, datetime}} {{timezone}}",
  "executionWithStartAndEndAndTimezoneNextDay": "{{start, datetime}} - {{end, datetime}} {{timezone}} (giorno successivo)",
  "executionWithStartAndEndNextDay": "{{start, datetime}} - {{end, datetime}} (giorno successivo)",
  "executionWithStartNextDay": "{{start, datetime}} (giorno successivo)",
  "helpBody": "Le pianificazioni vengono utilizzate per accendere e spegnere pompe o valvole in orari specifici o per durate specifiche. Le pianificazioni possono essere impostate per essere eseguite una volta o per essere ripetute in giorni specifici della settimana.\n\nLe pianificazioni devono essere sincronizzate con i dispositivi per funzionare correttamente, il che dovrebbe avvenire rapidamente, ma non immediatamente. Se non vedi la tua pianificazione in esecuzione quando ti aspetti, controlla lo stato di sincronizzazione. Se lo stato di sincronizzazione è \"Sincronizzazione non riuscita\", contatta l'assistenza FarmHQ.",
  "helpTitle": "Informazioni sugli orari",
  "manageScheduleTitle": "Gestisci la pianificazione",
  "new": "Nuovo",
  "nextDayParentheses": "(Giorno successivo)",
  "nextScheduleActionWithTimestamp": "Prossima azione programmata per {{timestamp, datetime}}",
  "noSchedules": "Nessuna azione pianificata trovata per il tuo account farm.",
  "noSchedulesActive": "Nessuna programmazione attiva trovata.",
  "noSchedulesExpired": "Nessuna azione programmata in passato trovata.",
  "repeatWeeklyOnDays": "Ripeti settimanalmente nei giorni:",
  "repeats": "Ripetizioni:",
  "scheduledActions": "Azioni pianificate",
  "schedulesActiveTitle": "Orari attivi",
  "schedulesExpiredTitle": "Programmi scaduti",
  "schedulesListTitle": "Programmi di irrigazione",
  "startTimeLabel": "Inizio",
  "status": "Stato",
  "syncStatus_FAILED": "Sincronizzazione non riuscita. Contatta l'assistenza.",
  "syncStatus_IN_PROGRESS": "Sincronizzazione con il dispositivo...",
  "syncStatus_SUCCESS": "Sincronizzato con il dispositivo.",
  "theFollowingScheduledActionWillBeCancelled": "La seguente azione programmata verrà annullata.",
  "thisWeek": "Questa settimana:",
  "time": "Tempo"
}
